var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\u0421\u043B\u043E\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 467 195",
    style: {
      enableBackground: "new 0 0 467 195"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#242424"
    },
    d: "M449.571,177.339H28.429c-6.854,0-11.813-6.545-9.958-13.144L43.883,73.82 c1.254-4.461,5.323-7.544,9.958-7.544h370.32c4.634,0,8.703,3.083,9.958,7.544l25.411,90.376 C461.384,170.793,456.425,177.339,449.571,177.339z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "18.079,152.485 18.239,168.736 24.553,163.777 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#242424"
    },
    points: "459.921,152.485 459.921,167.316 451.644,163.777 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E8E8"
    },
    d: "M449.571,163.777H28.429c-6.854,0-11.813-6.545-9.958-13.144l25.411-90.376 c1.254-4.461,5.323-7.544,9.958-7.544h370.32c4.634,0,8.703,3.083,9.958,7.544l25.411,90.376 C461.384,157.232,456.425,163.777,449.571,163.777z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#B0C4D8"
    },
    cx: 239,
    cy: 108.246,
    rx: 30.068,
    ry: 19.707
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.b4446df806f0d0ebf7ff24fb7b89df19.svg";
export { ForwardRef as ReactComponent };